module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-11.9e33217c.mp3";